import { render, staticRenderFns } from "./WorkIconExport.vue?vue&type=template&id=d327e0be"
import script from "./WorkIconExport.vue?vue&type=script&lang=js"
export * from "./WorkIconExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports